import { handleRequest } from "../utilities/requestHandler";


export const createOrder = (newCheckoutDetails) =>
    handleRequest("post","/orders/create",newCheckoutDetails);